import styled from "styled-components"
import multiavatar from "@multiavatar/multiavatar/esm"
import { CSSProperties } from "react"

export default function Avatar({ seed, size = 30, style }: { seed: string; size?: number; style?: CSSProperties }) {
  const svgCode = multiavatar(seed)
  return <Root size={size} dangerouslySetInnerHTML={{ __html: svgCode }} style={style} />
}

const Root = styled.div<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  margin: 0;
  padding: 0;
`
